import type { QuoterTranslations } from "../interfaces/quoter";

export const quoterTranslations: QuoterTranslations = {
  header_title: "Cotador de envios",
  header_subtitle: "Calcule suas transferências internacionais na hora.",
  header_history_button: "Histórico",

  step1_title: "Passo 1: O que você deseja fazer?",
  step1_send_title: "Quero enviar",
  step1_send_description: "Enviar dinheiro para outra moeda",
  step1_receive_title: "Quero receber",
  step1_receive_description: "Calcular quanto devo pagar",
  step1_rate_label: "Taxa de câmbio atual",
  step1_equiv_to: "equivale a",
  step1_quote_to_see_rate: "Cotar para ver a taxa",

  step2_title: "Passo 2: Detalhes do envio",
  step2_origin_label: "Moeda de origem",
  step2_destination_label: "Moeda de destino",
  step2_select_currency: "Selecionar moeda",
  step2_amount_send: "Valor a enviar",
  step2_amount_receive: "Valor a receber",
  step2_amount_placeholder: "Ex.: 1.000.000",
  step2_commission_label: "Comissão (%)",

  form_error_select_currencies: "Selecione a moeda de origem e destino.",
  form_error_valid_amount: "Digite um valor válido.",
  form_error_country_not_found: "País não encontrado para a moeda selecionada.",
  form_error_quote: "Erro ao obter a cotação.",
  form_button_quoting: "Cotando…",
  form_button_submit: "Cotar envio agora",

  summary_total_pay: "Total a pagar",
  summary_commission_suffix: "de comissão ({{percent}}%)",
  summary_amount_converted: "Valor convertido",
  summary_beneficiary_receives: "Total que o beneficiário recebe",

  result_title: "Resultado da cotação",
  result_amount_sent: "Valor enviado",
  result_amount_received: "Valor a receber",
  result_amount_converted: "Valor convertido",
  result_commission: "Comissão ({{percent}}%)",
  result_effective_rate_title: "Taxa Coloca",

  footer_secure: "Seguro",
  footer_instant: "Instantâneo",
  footer_copyright: "© 2024 Logística Global S.A. Todos os direitos reservados.",

  history_title: "Histórico de cotações",
  history_refresh: "Atualizar",
  history_back: "Voltar",
  history_no_permission: "Você não tem permissão para ver o histórico de cotações.",

  history_filters_title: "Filtros",
  history_filters_origin: "Moeda origem",
  history_filters_destination: "Moeda destino",
  history_filters_all: "Todas",
  history_filters_start_date: "Data de início",
  history_filters_end_date: "Data de fim",
  history_filters_apply: "Aplicar filtros",
  history_filters_clear: "Limpar filtros",

  history_table_showing_one: "Mostrando 1 cotação nesta página (Total: {{total}})",
  history_table_showing_many: "Mostrando {{count}} cotações nesta página (Total: {{total}})",
  history_table_show_label: "Mostrar:",
  history_table_empty: "Não há cotações para exibir.",
  history_table_th_origin: "Origem",
  history_table_th_destination: "Destino",
  history_table_th_send: "Envia",
  history_table_th_receive: "Recebe",
  history_table_th_commission: "Comissão %",
  history_table_th_rate: "Taxa",
  history_table_th_created_by: "Criado por",
  history_table_th_date: "Data",
  history_table_th_actions: "Ações",
  history_table_view_aria: "Ver cotação",
  history_table_view: "Ver",

  history_modal_title: "Detalhe da cotação",
  history_modal_close_aria: "Fechar",
  history_modal_error_load: "Não foi possível carregar o detalhe da cotação.",
  history_modal_amount_receive: "Valor a receber",
  history_modal_origin: "Origem",
  history_modal_destination: "Destino",
  history_modal_commission: "Comissão de transferência ({{percent}}%)",
  history_modal_total_debit: "Total a debitar",
  history_modal_created_by: "Criado por:",
  history_modal_date: "Data:",
  history_modal_close_button: "Fechar",

  history_pagination_records: "Registros de {{from}} a {{to}} de {{total}}",
  history_pagination_total_pages: "Total de páginas ({{lastPage}})",
  history_pagination_first_page: "Primeira página",
  history_pagination_prev_page: "Página anterior",
  history_pagination_next_page: "Página seguinte",
  history_pagination_last_page: "Última página",
};
